import { useRef, useEffect } from "react";
import * as d3 from "d3";
import { prop } from "ramda";
import { initAxes, updateAxes } from "@dataVisualizations/common/topBottomAxes";
import { initGrid, updateGridLines } from "@dataVisualizations/common/gridLines";
import { initGraph, updateValues, updateTooltip } from "./renderFunctions";
import useGraphRender from "@dataVisualizations/hooks/useGraphRender";
/*
 data = [
   { id: 'Riket', name: 'Riket', Kvinnor: 40, Män: 60, total: 100 },
   { id: 'Blekinge', name: 'Blekinge', Kvinnor: 20, Män: 80, total: 100 },
   { id: 'Halland', name: 'Halland', Kvinnor: 50, Män: 50, total: 100 }
 ]
*/
import { jsx as _jsx } from "react/jsx-runtime";
var margin = {
  left: 15,
  right: 25,
  bottom: 50,
  top: 20
};
export default function StackedBarchartGraph(_ref) {
  var data = _ref.data,
    activeLayers = _ref.activeLayers,
    measureUnit = _ref.measureUnit,
    layerKeys = _ref.layerKeys,
    containerRef = _ref.containerRef,
    colors = _ref.colors;
  var graphRef = useRef();
  var rowHeight = activeLayers.length === 2 ? 38 : 34;
  useEffect(function () {
    initGrid(graphRef.current, margin);
    initAxes(graphRef.current, margin);
    initGraph(graphRef.current, margin, data);
  }, [data]);
  var renderGraph = function renderGraph() {
    var _layers$;
    var layers = d3.stack().keys(layerKeys)(data);
    for (var i = 0; i < layers.length; i++) {
      for (var j = 0; j < layers[i].length; j++) {
        layers[i][j].key = layers[i].key;
      }
    }
    var height = layers[0] ? layers[0].length * rowHeight : 0;
    var width = containerRef.current.offsetWidth - margin.left - margin.right;
    var svg = d3.select(graphRef.current);
    svg = svg.attr("width", containerRef.current.offsetWidth).attr("height", height + margin.top + margin.bottom);
    var content = svg.select(".chartData");
    var x = d3.scaleLinear().domain([0, d3.max(data, prop("total"))]).nice().rangeRound([0, width]);
    var y = d3.scaleBand().domain(data.map(prop("id"))).rangeRound([0, height]).paddingInner([0.2]).paddingOuter([0.1]);
    var z = d3.scaleOrdinal().range(colors).domain(layerKeys); //connect colors to layerKeys

    var config = {
      data: layers,
      svg: svg,
      yTicks: ((_layers$ = layers[0]) === null || _layers$ === void 0 ? void 0 : _layers$.length) || 0,
      content: content,
      x: x,
      y: y,
      z: z,
      //scales
      measureUnit: measureUnit,
      width: width,
      height: height,
      margin: margin
    };
    updateGridLines(config);
    updateAxes(config);
    updateValues(config);
    updateTooltip(config);
    svg.selectAll(".tick").selectAll("line").style("stroke-width", "1px").style("stroke", "#e8e7e6");
    svg.style("shape-rendering", "crispedges");
  };
  useGraphRender(data, containerRef, renderGraph);
  return /*#__PURE__*/_jsx("svg", {
    ref: graphRef,
    className: "svg_content"
  });
}